<template>
  <div>
    <v-menu
      v-model="popup"
      @click.native.stop.prevent
      :close-on-content-click="false"
      offset-y
      left
      bottom
      absolute
      content-class="hyp-tree-menu"
    >
      <template v-slot:activator="{ on }">
        <v-icon
          v-if="showingDocuments"
          class="hyp-delete mr-3"
          title="Remove article from folder"
          size="11"
          @click.native.stop.prevent="handleClickDelete"
          >{{ deleteIcon }}</v-icon
        >
        <v-icon
          v-on="on"
          :class="{
            'hyp-pin': !showingAlerts,
            'hyp-pin-alerts': showingAlerts,
            'theme--dark white--text': isDarkTheme,
          }"
          title="Save article to folder"
          size="11"
          @click.native.stop.prevent
          >fas fa-folder-open</v-icon
        >
      </template>
      <div>
        <CollaborationTree
          :popup="true"
          :article="article"
          :initialize="initialize"
          :showing-documents="showingDocuments"
          @select="handleSelect"
        ></CollaborationTree>
      </div>
    </v-menu>
  </div>
</template>

<script>
import lodashDebounce from "lodash/debounce";
import { mapGetters } from "vuex";

import { MODULE_PREFIX_COLLABORATION } from "@/store";

const EMITTED_ACTIONS = {
  SELECT: "select",
  CLICK_DELETE: "click-delete",
};

export default {
  name: "CollaborationTreePopup",
  components: {
    CollaborationTree: () =>
      import("@/components/collaboration/CollaborationTree"),
  },
  props: {
    article: {
      type: Object,
    },
    type: {
      type: String,
      default: "tree",
    },
    showingDocuments: {
      type: Boolean,
      default: false,
    },
    showingAlerts: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
    },
  },
  data: () => ({
    popup: false,
    initial: true,
    initialize: null,
    loadingDelete: false,
  }),
  computed: {
    ...mapGetters({
      foldersChange: MODULE_PREFIX_COLLABORATION + "foldersChange",
    }),
    isDarkTheme() {
      return this.theme !== "light";
    },
    iconId() {
      return `icon-${this._uid}`;
    },
    deleteIcon() {
      if (this.loadingDelete) {
        return "fas fa-circle-notch fa-spin";
      }
      return "far fa-trash-alt";
    },
  },
  methods: {
    handleSelect(item) {
      this.$emit(EMITTED_ACTIONS.SELECT, item);
    },
    handleClickDelete(item) {
      this.loadingDelete = true;
      this.$emit(EMITTED_ACTIONS.CLICK_DELETE, item);
      lodashDebounce(() => {
        this.loadingDelete = false;
      }, 500)();
    },
  },
  watch: {
    popup: {
      handler() {
        if (this.popup && this.foldersChange) {
          this.initialize = new Date().toISOString();
        }
      },
    },
  },
  beforeDestroy() {
    this.loadingDelete = false;
  },
};
</script>

<style>
.hyp-delete.theme--light.v-icon {
  color: black !important;
}
.hyp-pin.theme--light.v-icon {
  color: black !important;
}
</style>

<style scoped>
.hyp-tree-menu {
  background-color: white !important;
  border-radius: 8px !important;
  min-width: 150px !important;
  max-height: 243px !important;
}
.hyp-tree-popup-container {
  background-color: white;
  padding: 5px 0 0 10px;
}
.hyp-delete {
  position: relative;
  top: -1px;
  cursor: pointer;
}
.hyp-pin {
  position: relative;
  top: -1px;
}
.hyp-pin-alerts {
  color: rgba(0, 0, 0, 0.87) !important;
  position: relative;
  top: -2px;
}
</style>
